import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Container } from "react-bootstrap";
import { FaCode, FaStar, FaCodeBranch } from "react-icons/fa";
import { GoRepo } from "react-icons/go";
import { BiGitMerge } from "react-icons/bi";
import "./GithubStyles.css";

function Github() {
  return (
    <Container fluid className="github-card">
      <div className="github-card-container">
        <h1 className="github-card-title">
          <FaCode style={{ marginBottom: "4px" }} /> GitHub Contributions
        </h1>
        <p className="github-card-description">
          Check out my GitHub contributions over time. I'm constantly working on new projects
          and improving my skills through open-source contributions.
        </p>

        <div className="github-calendar-container">
          <GitHubCalendar
            username="marwaniiwael18"
            blockSize={15}
            blockMargin={5}
            color="#c084f5"
            fontSize={16}
            hideColorLegend={false}
            hideMonthLabels={false}
          />
        </div>

        <div className="github-stats-container">
          <div className="github-stat">
            <div className="github-stat-icon">
              <GoRepo />
            </div>
            <div className="github-stat-content">
              <h3>30+ Repositories</h3>
              <p>Public & private projects</p>
            </div>
          </div>

          <div className="github-stat">
            <div className="github-stat-icon">
              <FaStar />
            </div>
            <div className="github-stat-content">
              <h3>Stars Earned</h3>
              <p>From the community</p>
            </div>
          </div>

          <div className="github-stat">
            <div className="github-stat-icon">
              <FaCodeBranch />
            </div>
            <div className="github-stat-content">
              <h3>100+ Contributions</h3>
              <p>Last year activity</p>
            </div>
          </div>

          <div className="github-stat">
            <div className="github-stat-icon">
              <BiGitMerge />
            </div>
            <div className="github-stat-content">
              <h3>50+ Pull Requests</h3>
              <p>Merged into projects</p>
            </div>
          </div>
        </div>

        <div className="github-link">
          Want to see more? <a href="https://github.com/marwaniiwael18" target="_blank" rel="noreferrer">Visit my GitHub profile</a>
        </div>

        <a
          href="https://github.com/marwaniiwael18"
          target="_blank"
          rel="noreferrer"
          className="github-view-btn"
        >
          <FaCode style={{ marginBottom: "2px" }} /> View GitHub Profile
        </a>
      </div>
    </Container>
  );
}

export default Github;